import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EntryFeedback } from '../conversationSlice';

interface CompetitorAlert {
  competitor: string;
  matched_text: string;
  confidence: number;
  match_type: string;
  advantages: Array<{ point: string; context?: string }>;
  weaknesses: Array<{ point: string; reason?: string }>;
  talking_points: string;
  category: string;
  detected_at: string;
  timestamp?: string;
  speaker: string;
  feedback?: EntryFeedback;
}

interface CompetitorState {
  alerts: CompetitorAlert[]; // Current alerts for display
  allAlerts: CompetitorAlert[]; // All accumulated alerts for session saving
  isConnected: boolean;
  connectionError: string | null;
}

const initialState: CompetitorState = {
  alerts: [],
  allAlerts: [], // Store all alerts for session saving
  isConnected: false,
  connectionError: null
};

const competitorSlice = createSlice({
  name: 'competitor',
  initialState,
  reducers: {
    addCompetitorAlert: (state, action: PayloadAction<CompetitorAlert>) => {
      // Add to display alerts (no limit)
      state.alerts = [action.payload, ...state.alerts];
      // Add to accumulated alerts for session saving
      state.allAlerts.push(action.payload);
    },
    removeCompetitorAlert: (state, action: PayloadAction<number>) => {
      state.alerts.splice(action.payload, 1);
    },
    clearCompetitorAlerts: (state) => {
      state.alerts = [];
      state.allAlerts = [];
    },
    setCompetitorConnectionStatus: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
      if (action.payload) {
        state.connectionError = null;
      }
    },
    setCompetitorConnectionError: (state, action: PayloadAction<string | null>) => {
      state.connectionError = action.payload;
    },
    updateCompetitorFeedback: (state, action: PayloadAction<{ detected_at: string; feedback: EntryFeedback }>) => {
      const updateIn = (arr: CompetitorAlert[]) => {
        const alert = arr.find(a => a.detected_at === action.payload.detected_at);
        if (alert) alert.feedback = action.payload.feedback;
      };
      updateIn(state.alerts);
      updateIn(state.allAlerts);
    }
  }
});

export const {
  addCompetitorAlert,
  removeCompetitorAlert,
  clearCompetitorAlerts,
  setCompetitorConnectionStatus,
  setCompetitorConnectionError,
  updateCompetitorFeedback
} = competitorSlice.actions;

export default competitorSlice.reducer;